import type { OrganizationResourceApi } from '@ingenico/api-sdk-provisioning-public';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { SvgAsset } from '@ingenico/react-ui/svg-asset';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './OSOrganizationsTabMobileRow.module.scss';

export interface OSOrganizationsTabMobileRowProps {
  readonly row: OrganizationResourceApi;
}

export function OSOrganizationsTabMobileRow({ row }: OSOrganizationsTabMobileRowProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.COMMON]);
  const location = `${row.location?.zipCode ?? ''} ${row.location?.city ?? ''} ${row.location?.address ?? ''}`.trim();
  const country = t(`field.country.${row.location?.country}`);

  return (
    <div className={styles.container}>
      <CoreTypography className={styles.column} variant={CoreTypographyVariant.Body01Medium}>
        {row.name}
      </CoreTypography>
      <CoreTypography className={styles.column} variant={CoreTypographyVariant.Body02Regular}>
        {country}
      </CoreTypography>
      <CoreTypography className={styles.column} variant={CoreTypographyVariant.Body02Regular}>
        {location}
      </CoreTypography>
      <SvgAsset image="arrow-mobile-data-grid" loadSvgAsIs />
    </div>
  );
}
